module.exports = __webpack_public_path__ + "public/img/liangbu_logo.d27bf995.jpg";